import React from 'react';
import { Row, Col, Breadcrumb, Space } from 'antd';
import { useTheme } from 'contexts/theme';
import Meta from '../blocks/meta';
import Header from '../blocks/header';
import Footer from '../blocks/footer';
import Sider from '../blocks/sider';
import ErrorBoundary from 'components/ErrorBoundary';

import styles from './dashboard.module.sass';

export default function DashboardLayout({
  children,
  title,
  path,
  extra
}: {
  children: React.ReactNode;
  title: string;
  path?: string[];
  extra?: React.ReactNode[];
}) {
  const { dark } = useTheme();
  return (
    <div className={dark ? styles['dashboard-dark'] : styles.dashboard}>
      <Meta title={title} />
      <Header />
      <Sider />
      <div className={styles.content}>
        {(path || extra) && (
          <Row gutter={5} align="middle" className={styles.row}>
            <Col md={12} xs={12}>
              <Breadcrumb>
                {path &&
                  path.map((item) => (
                    <Breadcrumb.Item key={item}>{item}</Breadcrumb.Item>
                  ))}
              </Breadcrumb>
            </Col>
            <Col md={12} className={styles.right} xs={12}>
              <Space size={5}>
                {extra &&
                  extra.map((item) => <span key={Math.random()}>{item}</span>)}
              </Space>
            </Col>
          </Row>
        )}
        <ErrorBoundary>{children}</ErrorBoundary>
      </div>
      <Footer />
    </div>
  );
}
